import { IcMinus } from "@jetblue/kit-icons/ic-minus";
import { IcPlus } from "@jetblue/kit-icons/ic-plus";
import { IncrementerButton } from "./incrementer-button";

const isMinimumDisabled = (
  isDisabled: boolean | undefined,
  minimum: number | undefined,
  value: number,
) => Boolean(isDisabled) || (typeof minimum === "number" && value <= minimum);

const isMaximumDisabled = (
  isDisabled: boolean | undefined,
  maximum: number | undefined,
  value: number,
) => Boolean(isDisabled) || (typeof maximum === "number" && value >= maximum);

export type IncrementerProperties = {
  increment: () => void;
  decrement: () => void;
  decrementLabel: string;
  incrementLabel: string;
  isDecrementDisabled?: boolean | undefined;
  isIncrementDisabled?: boolean | undefined;
  value: number;
  label?: string | undefined;
  minimum?: number | undefined;
  maximum?: number | undefined;
  name?: string | undefined;
};
export const Incrementer = ({
  incrementLabel,
  decrementLabel,
  decrement,
  increment,
  isDecrementDisabled,
  isIncrementDisabled,
  label,
  value,
  minimum,
  name,
  maximum,
}: IncrementerProperties) => (
  <span aria-label={label} className="flex h-max flex-row gap-2">
    <IncrementerButton
      isDisabled={isMinimumDisabled(isDecrementDisabled, minimum, value)}
      label={decrementLabel}
      onClick={decrement}
    >
      <IcMinus aria-hidden="true" className="size-6" />
    </IncrementerButton>
    <span
      aria-live="assertive"
      className="w-8 text-center text-body-extra-bold text-on-surface"
    >
      {value}
    </span>
    <input className="hidden" name={name} type="number" value={value} />
    <IncrementerButton
      isDisabled={isMaximumDisabled(isIncrementDisabled, maximum, value)}
      label={incrementLabel}
      onClick={increment}
    >
      <IcPlus aria-hidden="true" className="size-6" />
    </IncrementerButton>
  </span>
);
Incrementer.displayName = "Incrementer";

export { useIncrementer } from "./use-incrementer";
